module.exports = __webpack_public_path__ + "img/0026.95a6a84f.jpg";